// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/DropPromptModal/DropPromptModal.css */

.drop-prompt-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.drop-prompt-modal {
  background: white;
  border-radius: 12px;
  width: 400px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.drop-prompt-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
}

.drop-prompt-icon {
  font-size: 24px;
}

.drop-prompt-header h3 {
  flex: 1 1;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #1E293B;
}

.drop-prompt-header .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #64748B;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.drop-prompt-header .close-btn:hover {
  color: #1E293B;
}

.drop-prompt-content {
  padding: 20px;
}

.drop-prompt-template-name {
  margin: 0 0 20px;
  color: #64748B;
  font-size: 13px;
}

.drop-prompt-template-name strong {
  color: #1E293B;
}

.drop-prompt-options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.drop-prompt-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #F1F5F9;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
}

.drop-prompt-option:hover {
  background: #E2E8F0;
  border-color: #3B82F6;
}

.drop-prompt-option.create-new {
  background: #EFF6FF;
}

.drop-prompt-option.create-new:hover {
  background: #DBEAFE;
}

.drop-prompt-option .option-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3B82F6;
  color: white;
  border-radius: 50%;
  font-size: 18px;
  font-weight: bold;
}

.drop-prompt-option .option-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.drop-prompt-option .option-text strong {
  font-size: 14px;
  color: #1E293B;
}

.drop-prompt-option .option-text span {
  font-size: 12px;
  color: #64748B;
}

/* Existing items section */
.drop-prompt-existing {
  background: #F8FAFC;
  border-radius: 8px;
  padding: 12px 16px;
  border: 1px solid #E2E8F0;
}

.existing-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.existing-header .option-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #64748B;
  color: white;
  border-radius: 50%;
  font-size: 12px;
}

.existing-header strong {
  font-size: 14px;
  color: #1E293B;
}

.existing-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 150px;
  overflow-y: auto;
  margin-bottom: 12px;
}

.existing-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.existing-item:hover {
  border-color: #3B82F6;
  background: #F8FAFC;
}

.existing-item.selected {
  border-color: #3B82F6;
  background: #EFF6FF;
}

.existing-item input[type="radio"] {
  margin: 0;
}

.existing-item .item-name {
  font-size: 13px;
  color: #1E293B;
}

.btn-use-existing {
  width: 100%;
  padding: 8px 12px;
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-use-existing:hover:not(:disabled) {
  background: #2563EB;
}

.btn-use-existing:disabled {
  background: #CBD5E1;
  cursor: not-allowed;
}

/* Footer */
.drop-prompt-footer {
  padding: 12px 20px;
  background: #F8FAFC;
  border-top: 1px solid #E2E8F0;
  display: flex;
  justify-content: flex-end;
}

.drop-prompt-footer .btn-cancel {
  padding: 8px 16px;
  background: white;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 13px;
  color: #64748B;
  cursor: pointer;
}

.drop-prompt-footer .btn-cancel:hover {
  background: #F1F5F9;
  color: #1E293B;
}
`, "",{"version":3,"sources":["webpack://./src/components/DropPromptModal/DropPromptModal.css"],"names":[],"mappings":"AAAA,uDAAuD;;AAEvD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* src/components/DropPromptModal/DropPromptModal.css */\n\n.drop-prompt-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.drop-prompt-modal {\n  background: white;\n  border-radius: 12px;\n  width: 400px;\n  max-width: 90vw;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.drop-prompt-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #F8FAFC;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.drop-prompt-icon {\n  font-size: 24px;\n}\n\n.drop-prompt-header h3 {\n  flex: 1;\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1E293B;\n}\n\n.drop-prompt-header .close-btn {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #64748B;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n}\n\n.drop-prompt-header .close-btn:hover {\n  color: #1E293B;\n}\n\n.drop-prompt-content {\n  padding: 20px;\n}\n\n.drop-prompt-template-name {\n  margin: 0 0 20px;\n  color: #64748B;\n  font-size: 13px;\n}\n\n.drop-prompt-template-name strong {\n  color: #1E293B;\n}\n\n.drop-prompt-options {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.drop-prompt-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: #F1F5F9;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  text-align: left;\n}\n\n.drop-prompt-option:hover {\n  background: #E2E8F0;\n  border-color: #3B82F6;\n}\n\n.drop-prompt-option.create-new {\n  background: #EFF6FF;\n}\n\n.drop-prompt-option.create-new:hover {\n  background: #DBEAFE;\n}\n\n.drop-prompt-option .option-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #3B82F6;\n  color: white;\n  border-radius: 50%;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.drop-prompt-option .option-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.drop-prompt-option .option-text strong {\n  font-size: 14px;\n  color: #1E293B;\n}\n\n.drop-prompt-option .option-text span {\n  font-size: 12px;\n  color: #64748B;\n}\n\n/* Existing items section */\n.drop-prompt-existing {\n  background: #F8FAFC;\n  border-radius: 8px;\n  padding: 12px 16px;\n  border: 1px solid #E2E8F0;\n}\n\n.existing-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.existing-header .option-icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #64748B;\n  color: white;\n  border-radius: 50%;\n  font-size: 12px;\n}\n\n.existing-header strong {\n  font-size: 14px;\n  color: #1E293B;\n}\n\n.existing-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  max-height: 150px;\n  overflow-y: auto;\n  margin-bottom: 12px;\n}\n\n.existing-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.existing-item:hover {\n  border-color: #3B82F6;\n  background: #F8FAFC;\n}\n\n.existing-item.selected {\n  border-color: #3B82F6;\n  background: #EFF6FF;\n}\n\n.existing-item input[type=\"radio\"] {\n  margin: 0;\n}\n\n.existing-item .item-name {\n  font-size: 13px;\n  color: #1E293B;\n}\n\n.btn-use-existing {\n  width: 100%;\n  padding: 8px 12px;\n  background: #3B82F6;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.btn-use-existing:hover:not(:disabled) {\n  background: #2563EB;\n}\n\n.btn-use-existing:disabled {\n  background: #CBD5E1;\n  cursor: not-allowed;\n}\n\n/* Footer */\n.drop-prompt-footer {\n  padding: 12px 20px;\n  background: #F8FAFC;\n  border-top: 1px solid #E2E8F0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.drop-prompt-footer .btn-cancel {\n  padding: 8px 16px;\n  background: white;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 13px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.drop-prompt-footer .btn-cancel:hover {\n  background: #F1F5F9;\n  color: #1E293B;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
